var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "File-user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 19.5,
    viewBox: "0 0 15.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .fileUser{fill:#1bc47d}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "File-user-2",
    "data-name": "File-user",
    transform: "translate(-.25 -.25)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "fileUser",
    d: "M2 0a2 2 0 1 0 2 2 2 2 0 0 0-2-2z",
    transform: "translate(6 7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    className: "fileUser",
    d: "M0 3a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3 1 1 0 0 1-1 1H1a1 1 0 0 1-1-1z",
    transform: "translate(4 12.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M12.75 19.5h-10A2.754 2.754 0 0 1 0 16.75v-14A2.754 2.754 0 0 1 2.75 0h7.987a1.753 1.753 0 0 1 1.421.73l3.013 4.2a1.734 1.734 0 0 1 .329 1.018v10.8a2.753 2.753 0 0 1-2.75 2.752zm-10-18A1.252 1.252 0 0 0 1.5 2.75v14A1.252 1.252 0 0 0 2.75 18h10A1.252 1.252 0 0 0 14 16.75V6.647h-3.25A.751.751 0 0 1 10 5.9V1.5z",
    transform: "translate(.25 .25)",
    style: {
      fill: "#8c8d99"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUser);
export default __webpack_public_path__ + "static/media/file-user.24f64bb08846e53c492711fe700a5b68.svg";
export { ForwardRef as ReactComponent };